import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.companyPickupAddress || initialState;

export const selectCompanyPickupAddreses = createSelector(
  [selectDomain],
  (state) => state.pickupAddresses
);
export const selectTotalAddresses = createSelector(
  [selectDomain],
  (state) => state.totalAddresses
);
export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);
export const selectAddressCount = createSelector(
  [selectDomain],
  (state) => state.addressCount
);

export const selectCompanyDetails = createSelector(
  [selectDomain],
  (state) => state.companyDetails
);

export const selectCountries = createSelector(
  [selectDomain],
  (state) => state.countries
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectCities = createSelector(
  [selectDomain],
  (state) => state.cities
);
